// removed by extract-text-webpack-plugin
module.exports = {"MainContent":"Layout__MainContent__39U-c","Wrap":"Layout__Wrap__5feST"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Layout/Layout.css
// module id = 59
// module chunks = 0